import React from 'react';
import { NewContactFormCreate } from '../../../features/user/journalist/newContact/NewContactFormContainer';

export const CreateNewGuest: React.FC<{ saveRef: React.MutableRefObject<null> }
> = (props) => {
  const { saveRef } = props;

  return <NewContactFormCreate saveRef={saveRef} />;
};
